import { ImageRequire } from '../../../types';

const hintImages: Record<string, {imgName: string, uri: ImageRequire}> = {
  cubes1h: {
    imgName: '1-cubes-h',
    uri: require('../../../assets/images/1-cubes-h.png')
  },
  cubes2h: {
    imgName: '2-cubes-h',
    uri: require('../../../assets/images/2-cubes-h.png')
  },
  cubes3h: {
    imgName: '3-cubes-h',
    uri: require('../../../assets/images/3-cubes-h.png')
  },
  cubes4h: {
    imgName: '4-cubes-h',
    uri: require('../../../assets/images/4-cubes-h.png')
  },
  cubes5h: {
    imgName: '5-cubes-h',
    uri: require('../../../assets/images/5-cubes-h.png')
  },
  cubes6h: {
    imgName: '6-cubes-h',
    uri: require('../../../assets/images/6-cubes-h.png')
  },
  cubes7h: {
    imgName: '7-cubes-h',
    uri: require('../../../assets/images/7-cubes-h.png')
  },
  cubes8h: {
    imgName: '8-cubes-h',
    uri: require('../../../assets/images/8-cubes-h.png')
  },
  cubes9h: {
    imgName: '9-cubes-h',
    uri: require('../../../assets/images/9-cubes-h.png')
  },
  cubes10h: {
    imgName: '10-cubes-h',
    uri: require('../../../assets/images/10-cubes-h.png')
  },
  cubes11h: {
    imgName: '11-cubes-h',
    uri: require('../../../assets/images/11-cubes-h.png')
  },
  cubes12h: {
    imgName: '12-cubes-h',
    uri: require('../../../assets/images/12-cubes-h.png')
  },
  red1: {
    imgName: 'Red1',
    uri: require('../../../assets/images/1-redcube.png')
  },
  red2: {
    imgName: 'Red2',
    uri: require('../../../assets/images/2-redcube.png')
  },
  red3: {
    imgName: 'Red3',
    uri: require('../../../assets/images/3-redcube.png')
  },
  red4: {
    imgName: 'Red4',
    uri: require('../../../assets/images/4-redcube.png')
  },
  red5: {
    imgName: 'Red5',
    uri: require('../../../assets/images/5-redcube.png')
  },
  red6: {
    imgName: 'Red6',
    uri: require('../../../assets/images/6-redcube.png')
  },
  red7: {
    imgName: 'Red7',
    uri: require('../../../assets/images/7-redcube.png')
  },
  red8: {
    imgName: 'Red8',
    uri: require('../../../assets/images/8-redcube.png')
  },
  red9: {
    imgName: 'Red9',
    uri: require('../../../assets/images/9-redcube.png')
  },
  yellow1: {
    imgName: 'Yellow1',
    uri: require('../../../assets/images/1-yellowcube.png')
  },
  yellow1sub: {
    imgName: 'Yellow1Sub',
    uri: require('../../../assets/images/1-yellowcubesub.png')
  },
  red1sub: {
    imgName: 'Red1sub',
    uri: require('../../../assets/images/1-redcubesub.png')
  },
  red2sub: {
    imgName: 'Red2sub',
    uri: require('../../../assets/images/2-redcubesub.png')
  },
  red3sub: {
    imgName: 'Red3sub',
    uri: require('../../../assets/images/3-redcubesub.png')
  },
  red4sub: {
    imgName: 'Red4sub',
    uri: require('../../../assets/images/4-redcubesub.png')
  },
  red5sub: {
    imgName: 'Red5sub',
    uri: require('../../../assets/images/5-redcubesub.png')
  },

  // 1
  red1_0sub: {
    imgName: 'Red1_0sub',
    uri: require('../../../assets/images/1-0-redcube.png')
  },
  red1_1sub: {
    imgName: 'Red1_1sub',
    uri: require('../../../assets/images/1-1-redcube.png')
  },

  // 2
  red2_0sub: {
    imgName: 'Red2_0sub',
    uri: require('../../../assets/images/2-0-redcube.png')
  },
  red2_1sub: {
    imgName: 'Red2_1sub',
    uri: require('../../../assets/images/2-1-redcube.png')
  },
  red2_2sub: {
    imgName: 'Red2_2sub',
    uri: require('../../../assets/images/2-2-redcube.png')
  },

  // 3
  red3_0sub: {
    imgName: 'Red3_0sub',
    uri: require('../../../assets/images/3-0-redcube.png')
  },
  red3_1sub: {
    imgName: 'Red3_1sub',
    uri: require('../../../assets/images/3-1-redcube.png')
  },
  red3_2sub: {
    imgName: 'Red3_2sub',
    uri: require('../../../assets/images/3-2-redcube.png')
  },
  red3_3sub: {
    imgName: 'Red3_3sub',
    uri: require('../../../assets/images/3-3-redcube.png')
  },

  // 4
  red4_0sub: {
    imgName: 'Red4_0sub',
    uri: require('../../../assets/images/4-0-redcube.png')
  },
  red4_1sub: {
    imgName: 'Red4_1sub',
    uri: require('../../../assets/images/4-1-redcube.png')
  },
  red4_2sub: {
    imgName: 'Red4_2sub',
    uri: require('../../../assets/images/4-2-redcube.png')
  },
  red4_3sub: {
    imgName: 'Red4_3sub',
    uri: require('../../../assets/images/4-3-redcube.png')
  },
  red4_4sub: {
    imgName: 'Red4_4sub',
    uri: require('../../../assets/images/4-4-redcube.png')
  },

  // 5
  red5_0sub: {
    imgName: 'Red5_0sub',
    uri: require('../../../assets/images/5-0-redcube.png')
  },
  red5_1sub: {
    imgName: 'Red5_1sub',
    uri: require('../../../assets/images/5-1-redcube.png')
  },
  red5_2sub: {
    imgName: 'Red5_2sub',
    uri: require('../../../assets/images/5-2-redcube.png')
  },
  red5_3sub: {
    imgName: 'Red5_3sub',
    uri: require('../../../assets/images/5-3-redcube.png')
  },
  red5_4sub: {
    imgName: 'Red5_4sub',
    uri: require('../../../assets/images/5-4-redcube.png')
  },
  red5_5sub: {
    imgName: 'Red5_5sub',
    uri: require('../../../assets/images/5-5-redcube.png')
  },

  // 6
  red6_0sub: {
    imgName: 'Red6_0sub',
    uri: require('../../../assets/images/6-0-redcube.png')
  },
  red6_1sub: {
    imgName: 'Red6_1sub',
    uri: require('../../../assets/images/6-1-redcube.png')
  },
  red6_2sub: {
    imgName: 'Red6_2sub',
    uri: require('../../../assets/images/6-2-redcube.png')
  },
  red6_3sub: {
    imgName: 'Red6_3sub',
    uri: require('../../../assets/images/6-3-redcube.png')
  },
  red6_4sub: {
    imgName: 'Red6_4sub',
    uri: require('../../../assets/images/6-4-redcube.png')
  },
  red6_5sub: {
    imgName: 'Red6_5sub',
    uri: require('../../../assets/images/6-5-redcube.png')
  },
  red6_6sub: {
    imgName: 'Red6_6sub',
    uri: require('../../../assets/images/6-6-redcube.png')
  },

  // 7
  red7_0sub: {
    imgName: 'Red7_0sub',
    uri: require('../../../assets/images/7-0-redcube.png')
  },
  red7_1sub: {
    imgName: 'Red7_1sub',
    uri: require('../../../assets/images/7-1-redcube.png')
  },
  red7_2sub: {
    imgName: 'Red7_2sub',
    uri: require('../../../assets/images/7-2-redcube.png')
  },
  red7_3sub: {
    imgName: 'Red7_3sub',
    uri: require('../../../assets/images/7-3-redcube.png')
  },
  red7_4sub: {
    imgName: 'Red7_4sub',
    uri: require('../../../assets/images/7-4-redcube.png')
  },
  red7_5sub: {
    imgName: 'Red7_5sub',
    uri: require('../../../assets/images/7-5-redcube.png')
  },
  red7_6sub: {
    imgName: 'Red7_6sub',
    uri: require('../../../assets/images/7-6-redcube.png')
  },
  red7_7sub: {
    imgName: 'Red7_7sub',
    uri: require('../../../assets/images/7-7-redcube.png')
  },

  // 8
  red8_0sub: {
    imgName: 'Red8_0sub',
    uri: require('../../../assets/images/8-0-redcube.png')
  },
  red8_1sub: {
    imgName: 'Red8_1sub',
    uri: require('../../../assets/images/8-1-redcube.png')
  },
  red8_2sub: {
    imgName: 'Red8_2sub',
    uri: require('../../../assets/images/8-2-redcube.png')
  },
  red8_3sub: {
    imgName: 'Red8_3sub',
    uri: require('../../../assets/images/8-3-redcube.png')
  },
  red8_4sub: {
    imgName: 'Red8_4sub',
    uri: require('../../../assets/images/8-4-redcube.png')
  },
  red8_5sub: {
    imgName: 'Red8_5sub',
    uri: require('../../../assets/images/8-5-redcube.png')
  },
  red8_6sub: {
    imgName: 'Red8_6sub',
    uri: require('../../../assets/images/8-6-redcube.png')
  },
  red8_7sub: {
    imgName: 'Red8_7sub',
    uri: require('../../../assets/images/8-7-redcube.png')
  },
  red8_8sub: {
    imgName: 'Red8_8sub',
    uri: require('../../../assets/images/8-8-redcube.png')
  },

  // 9
  red9_0sub: {
    imgName: 'Red9_0sub',
    uri: require('../../../assets/images/9-0-redcube.png')
  },
  red9_1sub: {
    imgName: 'Red9_1sub',
    uri: require('../../../assets/images/9-1-redcube.png')
  },
  red9_2sub: {
    imgName: 'Red9_2sub',
    uri: require('../../../assets/images/9-2-redcube.png')
  },
  red9_3sub: {
    imgName: 'Red9_3sub',
    uri: require('../../../assets/images/9-3-redcube.png')
  },
  red9_4sub: {
    imgName: 'Red9_4sub',
    uri: require('../../../assets/images/9-4-redcube.png')
  },
  red9_5sub: {
    imgName: 'Red9_5sub',
    uri: require('../../../assets/images/9-5-redcube.png')
  },
  red9_6sub: {
    imgName: 'Red9_6sub',
    uri: require('../../../assets/images/9-6-redcube.png')
  },
  red9_7sub: {
    imgName: 'Red9_7sub',
    uri: require('../../../assets/images/9-7-redcube.png')
  },
  red9_8sub: {
    imgName: 'Red9_8sub',
    uri: require('../../../assets/images/9-8-redcube.png')
  },
  red9_9sub: {
    imgName: 'Red9_9sub',
    uri: require('../../../assets/images/9-9-redcube.png')
  },

  // 10
  red10_0sub: {
    imgName: 'Red10_0sub',
    uri: require('../../../assets/images/10-0-redcube.png')
  },
  red10_1sub: {
    imgName: 'Red10_1sub',
    uri: require('../../../assets/images/10-1-redcube.png')
  },
  red10_2sub: {
    imgName: 'Red10_2sub',
    uri: require('../../../assets/images/10-2-redcube.png')
  },
  red10_3sub: {
    imgName: 'Red10_3sub',
    uri: require('../../../assets/images/10-3-redcube.png')
  },
  red10_4sub: {
    imgName: 'Red10_4sub',
    uri: require('../../../assets/images/10-4-redcube.png')
  },
  red10_5sub: {
    imgName: 'Red10_5sub',
    uri: require('../../../assets/images/10-5-redcube.png')
  },
  red10_6sub: {
    imgName: 'Red10_6sub',
    uri: require('../../../assets/images/10-6-redcube.png')
  },
  red10_7sub: {
    imgName: 'Red10_7sub',
    uri: require('../../../assets/images/10-7-redcube.png')
  },
  red10_8sub: {
    imgName: 'Red10_8sub',
    uri: require('../../../assets/images/10-8-redcube.png')
  },
  red10_9sub: {
    imgName: 'Red10_9sub',
    uri: require('../../../assets/images/10-9-redcube.png')
  },
  red10_10sub: {
    imgName: 'Red10_10sub',
    uri: require('../../../assets/images/10-10-redcube.png')
  },

};

export { hintImages };
